import "core-js/modules/es.array.slice.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-8fa6b6e0"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  "class": "transaction-info"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_table_column = _resolveComponent("el-table-column");

  var _component_el_table = _resolveComponent("el-table");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("h3", null, _toDisplayString(_ctx.$t("label.sell")) + " " + _toDisplayString(_ctx.$t("label.list")), 1), _createVNode(_component_el_table, {
    data: $props.sellPrices.slice(-3),
    style: {
      "width": "100%",
      "color": "red"
    },
    onRowClick: $options.handleRowClick
  }, {
    "default": _withCtx(function () {
      return [_createVNode(_component_el_table_column, {
        prop: "price",
        label: _ctx.$t('label.sell') + _ctx.$t('label.price')
      }, null, 8, ["label"]), _createVNode(_component_el_table_column, {
        prop: "quantity",
        label: _ctx.$t('label.quantity')
      }, null, 8, ["label"])];
    }),
    _: 1
  }, 8, ["data", "onRowClick"]), _createElementVNode("h3", null, _toDisplayString(_ctx.$t("label.buy")) + " " + _toDisplayString(_ctx.$t("label.list")), 1), _createVNode(_component_el_table, {
    data: $props.buyPrices.slice(0, 3),
    style: {
      "width": "100%",
      "color": "green"
    },
    onRowClick: $options.handleRowClick
  }, {
    "default": _withCtx(function () {
      return [_createVNode(_component_el_table_column, {
        prop: "price",
        label: _ctx.$t('label.buy') + _ctx.$t('label.price')
      }, null, 8, ["label"]), _createVNode(_component_el_table_column, {
        prop: "quantity",
        label: _ctx.$t('label.quantity')
      }, null, 8, ["label"])];
    }),
    _: 1
  }, 8, ["data", "onRowClick"])]);
}